import { ErrorHandler, inject, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AppInsightsService } from './appinsights.service';
import { SHARED_ENVIRONMENT } from '@k12/app-services';

// This is V1 of this service
// Right now, we'll capture logs and errors to console and app insights
// V2 will implement app config and console will then be toggleable

@Injectable({ providedIn: 'root' })
export class CFIErrorHandlerService extends ErrorHandler {
    private readonly appInsights = inject(AppInsightsService);
    private readonly sharedEnv = inject(SHARED_ENVIRONMENT);
    public disableConsole: boolean = false;
    
    constructor(
    ) {
        super();
    }

    override handleError(error: unknown): void {
        // app name (eg: admin) : environment (eg: development) : actual error
        // sharedEnv.app and sharedEnv.name come from environment files

        if (error instanceof HttpErrorResponse) {
            this.appInsights.logEvent(`${this.sharedEnv.app}: ${this.sharedEnv.name}: http error`, { status: error.status, message: error.message })
            if (!this.disableConsole) {
                console.log("Http error", error.message);
            }
        } else if (error instanceof Error && error.message.length) {
                this.appInsights.logEvent(`${this.sharedEnv.app}: ${this.sharedEnv.name}: client error`, { message: error.message })
                if (!this.disableConsole) {
                    console.log("Client error", error.message);
                }
            }
    }

    // disable console
    disableConsoleLogging(disable: boolean) {
        this.disableConsole = disable;
        if (disable && globalThis) {
            globalThis.console.log = function () { };
            globalThis.console.error = function () { };
            globalThis.console.warn = function () { };
            globalThis.console.info = function () { };
            globalThis.console.debug = function () { };
        }
    }
}
